module.exports = {
	"kind": "analytics#gaData",
	"id": "https://www.googleapis.com/analytics/v3/data/ga?ids=ga:149014470&dimensions=ga:eventAction,+ga:eventLabel&metrics=ga:uniqueEvents&filters=ga:eventCategory%3D%3Dvideo;ga:eventAction%3D%3Dplayed,ga:eventAction%3D%3Dcomplete&start-date=30daysAgo&end-date=today",
	"query": {
		"start-date": "30daysAgo",
		"end-date": "today",
		"ids": "ga:149014470",
		"dimensions": "ga:eventAction, ga:eventLabel",
		"metrics": [
			"ga:uniqueEvents"
		],
		"filters": "ga:eventCategory==video;ga:eventAction==played,ga:eventAction==complete",
		"start-index": 1,
		"max-results": 1000
	},
	"itemsPerPage": 1000,
	"totalResults": 19,
	"selfLink": "https://www.googleapis.com/analytics/v3/data/ga?ids=ga:149014470&dimensions=ga:eventAction,+ga:eventLabel&metrics=ga:uniqueEvents&filters=ga:eventCategory%3D%3Dvideo;ga:eventAction%3D%3Dplayed,ga:eventAction%3D%3Dcomplete&start-date=30daysAgo&end-date=today",
	"profileInfo": {
		"profileId": "149014470",
		"accountId": "40985004",
		"webPropertyId": "UA-40985004-2",
		"internalWebPropertyId": "144352240",
		"profileName": "All Mobile App Data",
		"tableId": "ga:149014470"
	},
	"containsSampledData": false,
	"columnHeaders": [
		{
			"name": "ga:eventAction",
			"columnType": "DIMENSION",
			"dataType": "STRING"
		},
		{
			"name": "ga:eventLabel",
			"columnType": "DIMENSION",
			"dataType": "STRING"
		},
		{
			"name": "ga:uniqueEvents",
			"columnType": "METRIC",
			"dataType": "INTEGER"
		}
	],
	"totalsForAllResults": {
		"ga:uniqueEvents": "28"
	},
	"rows": [
		[
			"complete",
			"(not set)",
			"1"
		],
		[
			"complete",
			"Fortune Favours the Brave",
			"1"
		],
		[
			"complete",
			"Getting The Best Out of You and Your Team",
			"1"
		],
		[
			"complete",
			"Member Event with Ajaz Ahmed, Freeserve",
			"1"
		],
		[
			"complete",
			"Member Event with Charlie Hoult",
			"1"
		],
		[
			"complete",
			"Member Event: Wayne Hemingway, Hemingway Design",
			"1"
		],
		[
			"complete",
			"Succession or Sale?",
			"1"
		],
		[
			"played",
			"(not set)",
			"1"
		],
		[
			"played",
			"Exchange Event, Managing Change",
			"2"
		],
		[
			"played",
			"Fortune Favours the Brave",
			"3"
		],
		[
			"played",
			"Getting The Best Out of You and Your Team",
			"1"
		],
		[
			"played",
			"Member Event with Ajaz Ahmed, Freeserve",
			"1"
		],
		[
			"played",
			"Member Event with Charlie Hoult",
			"4"
		],
		[
			"played",
			"Member Event with Julian Leighton, Orange Bus",
			"2"
		],
		[
			"played",
			"Member Event: Wayne Hemingway, Hemingway Design",
			"3"
		],
		[
			"played",
			"OMCTJk8NL_Y",
			"1"
		],
		[
			"played",
			"Peter Roberts, Pure Gym",
			"1"
		],
		[
			"played",
			"Sara Davies, Crafters Companion",
			"1"
		],
		[
			"played",
			"Succession or Sale?",
			"1"
		]
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/outcomes.json
 ** module id = 762
 ** module chunks = 0
 **/